import { MatPaginatorIntl } from '@angular/material/paginator';

export class CustomMatPaginatorIntl extends MatPaginatorIntl {

  itemsPerPageLabel = 'Elementos por página: ';  

  constructor() {
    super();
  }
}